export const gradientMaker = {
  checkGradientAndReturnTheColors,
  returnGradientColorsForThisQuestion
}
const defaultColors = [
  '#E94212',
  '#ED5E0E',
  '#F27A0B',
  '#F79507',
  '#FBB003',
  '#FDC900',
  '#D4C30D',
  '#AABA19',
  '#80B326',
  '#57AB32',
  '#29A340'
]
const defaultColors1to5 = [
  '#E94212',
  '#ED5E0E',
  '#FBB003',
  '#AABA19',
  '#29A340'
]
const colors = {
  nps: {
    '10num': defaultColors
  },
  csat: {
    '5num': defaultColors1to5,
    '10num': defaultColors
  },
  ces: {
    // ainda não existe o ces, depois será feito
    '1to7': [
      '#f22020',
      '#f22020',
      '#f25b20',
      '#f4b622',
      '#c2d924',
      '#26bb07',
      '#26bb07'
    ],
    '1to7button': [
      '#f22020',
      '#f22020',
      '#f25b20',
      '#f4b622',
      '#c2d924',
      '#26bb07',
      '#26bb07'
    ]
  },
  nes: {
    // na v2 ainda não tem o nes de 1 a 7 botões, precisa confirmar com o rafa (provavelmente não terá)
    // mas basicamente o nes inverte as cores dos botões, vem o verde primeiro até ficar vermelho
    // quanto menor a opção escolhida menor é o esforço (nes é uma métrica de esforço)
    '1to7': [
      '#26bb07',
      '#26bb07',
      '#c2d924',
      '#f4b622',
      '#f25b20',
      '#f22020',
      '#f22020'
    ],
    '10num': [
      '#29A340',
      '#AABA19',
      '#FBB003',
      '#ED5E0E',
      '#E94212'
    ]
  },
  enum: {
    11: defaultColors,
    10: defaultColors, // somente 10 cores, mas não fica estranho se usarmos as cores padrões que são 11 opções
    6: ['#E94212', '#ED5E0E', '#FBB003', '#FDC900', '#AABA19', '#29A340'],
    5: defaultColors1to5
  }
}

/**
 * Manipula o objeto enviado por parãmetro para validar se necessita de cores especiais, inserindo-as conforme a UI e Tipo da pergunta
 *
 * @param {Object} question contém a questão que será manipulada e verificada a grade de cores
 */
function checkGradientAndReturnTheColors (type, ui, items) {
  const isGradiendMapped = returnGradientColorsForThisQuestion(type, ui, items)

  if (isGradiendMapped) {
    items.forEach((item, index) => {
      try {
        item.order = new Date().getTime()
        item.bgColor = isGradiendMapped[index]
        item.hoverColor = isGradiendMapped[index] + '90' // insere cores mais claras para a cor atual, dando um efeito de "vidro" ou sombra branca na cor atual
      } catch (error) {
        console.log('error', error)
        return []
      }
    })
  }
}

function returnGradientColorsForThisQuestion (type, ui, items) {
  try {
    if (type === 'enum') {
      return colors[type][items.length]
    }
    return colors[type][ui]
  } catch (e) {
    return []
  }
}
